var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 0.5H30.125C29.6875 0.5 29.375 0.875 29.375 1.25V8.1875C26.625 3.625 21.6875 0.5 16 0.5C7.6875 0.5 0.875 7.0625 0.5 15.25C0.4375 15.6875 0.8125 16 1.25 16H1.875C2.25 16 2.5625 15.75 2.625 15.3125C3 8.3125 8.8125 2.625 16 2.625C21.125 2.625 25.625 5.625 27.875 9.875H20.75C20.3125 9.875 20 10.25 20 10.625V11.25C20 11.6875 20.3125 12 20.75 12H30.75C31.125 12 31.5 11.6875 31.5 11.25V1.25C31.5 0.875 31.125 0.5 30.75 0.5ZM30.6875 16H30.0625C29.6875 16 29.375 16.3125 29.3125 16.75C28.9375 23.8125 23.125 29.375 16 29.375C10.8125 29.375 6.3125 26.5 4.0625 22.125H11.25C11.625 22.125 12 21.8125 12 21.375V20.75C12 20.375 11.625 20 11.25 20H1.25C0.8125 20 0.5 20.375 0.5 20.75V30.75C0.5 31.1875 0.8125 31.5 1.25 31.5H1.875C2.25 31.5 2.625 31.1875 2.625 30.75V23.875C5.3125 28.4375 10.25 31.5 16 31.5C24.25 31.5 31.0625 25 31.4375 16.8125C31.5 16.375 31.125 16 30.6875 16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.2301e689fc1981f74a7ebfea7bd15465.svg";
export { ForwardRef as ReactComponent };